module.exports = __webpack_public_path__ + "img/6.6ca44a09.jpg";;
if (typeof window !== 'undefined') {
(window.__IMAGE_SIZES__ || (window.__IMAGE_SIZES__ = {}))[module.exports] = {"width":1062,"height":1448,"variants":[{"file":"img/6-480w.05671aefc41c.webp","width":480},{"file":"img/6-960w.b8ac6715cf9a.webp","width":960},{"file":"img/6-1062w.1e8c0114ab59.webp","width":1062}]};
}